"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredType = exports.QuestionType = exports.AvailableCategoriesWithDataArray = exports.AvailableCategories = exports.Categories = exports.toPrefix = exports.fromPrefix = void 0;
exports.fromPrefix = '_from_';
exports.toPrefix = '_to_';
var Categories;
(function (Categories) {
    Categories["Sort"] = "sort";
    Categories["Fill"] = "fill";
    Categories["Seal"] = "seal";
    Categories["Label"] = "label";
    Categories["Packaging"] = "packaging";
})(Categories = exports.Categories || (exports.Categories = {}));
exports.AvailableCategories = [
    Categories.Sort,
    Categories.Fill,
    Categories.Seal,
    Categories.Label,
    Categories.Packaging
];
exports.AvailableCategoriesWithDataArray = [
    'sort.sortAndFeed',
    'sort.stockpile',
    'fill',
    'seal',
    'label',
    'packaging'
];
var QuestionType;
(function (QuestionType) {
    QuestionType["String"] = "string";
    QuestionType["LongString"] = "longString";
    QuestionType["Boolean"] = "boolean";
    QuestionType["YesNo"] = "yesNo";
    QuestionType["MultiChoice"] = "multiChoice";
    QuestionType["SingleChoice"] = "singleChoice";
    QuestionType["SingleChoiceSelect"] = "singleChoiceSelect";
    QuestionType["Float"] = "float";
    QuestionType["NonEmptyArray"] = "nonEmptyArray";
    QuestionType["Array"] = "array";
    QuestionType["File"] = "file";
    QuestionType["Date"] = "date";
})(QuestionType = exports.QuestionType || (exports.QuestionType = {}));
var RequiredType;
(function (RequiredType) {
    RequiredType["MinOne"] = "minOne";
    RequiredType["MaxOne"] = "maxOne";
    RequiredType["OnlyOne"] = "onlyOne";
    RequiredType["All"] = "all";
    RequiredType["Specific"] = "specific";
})(RequiredType = exports.RequiredType || (exports.RequiredType = {}));
//# sourceMappingURL=project.js.map